// extracted by mini-css-extract-plugin
export var button = "_mh-2";
export var card = "_mh-0";
export var closeButtonContainer = "_mh-3";
export var iconContainer = "_mh-1";